import { render, staticRenderFns } from "./CoordinateDisplayCard.vue?vue&type=template&id=3ec8b61a&scoped=true"
import script from "./CoordinateDisplayCard.vue?vue&type=script&lang=js"
export * from "./CoordinateDisplayCard.vue?vue&type=script&lang=js"
import style0 from "./CoordinateDisplayCard.vue?vue&type=style&index=0&id=3ec8b61a&prod&lang=scss&scoped=true"
import style1 from "./CoordinateDisplayCard.vue?vue&type=style&index=1&id=3ec8b61a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ec8b61a",
  null
  
)

export default component.exports